import React from "react";
import { Box } from "theme-ui";

import { Table, TableWrapper, TD, TH, TR } from "components/DataTable";

function PaymentProductList({
  list,
}: {
  list?: Array<{
    productName: string;
    saleQty: number;
    saleAmt: number;
  }>;
}) {
  return (
    <TableWrapper>
      <Table>
        <colgroup>
          <col width={`${(1 / 3) * 100}%`} />
          <col width={`${(1 / 3) * 100}%`} />
          <col width={`${(1 / 3) * 100}%`} />
        </colgroup>
        <Box as='thead'>
          <TR>
            <TH>상품명</TH>
            <TH>수량</TH>
            <TH>금액</TH>
          </TR>
        </Box>
        <Box as='tbody'>
          {list && list.map((data, index) => (
            <TR key={index}>
              <TD>{data.productName}</TD>
              <TD>{data.saleQty.toLocaleString()}</TD>
              <TD>
                {(Number(data.saleAmt)).toLocaleString()}원
              </TD>
            </TR>
          ))}
        </Box>
      </Table>
    </TableWrapper>
  );
}

export default PaymentProductList;
